import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Container, Typography, CircularProgress, Button } from '@mui/material';
import { Link } from 'react-router-dom';

const Success = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const location = useLocation();

  useEffect(() => {
    const sessionId = new URLSearchParams(location.search).get('session_id');
    if (sessionId) {
      setLoading(false);
    } else {
      setError('No session ID found');
      setLoading(false);
    }
  }, [location]);

  if (loading) {
    return (
      <Container sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress />
      </Container>
    );
  }

  if (error) {
    return (
      <Container sx={{ py: 8, textAlign: 'center' }}>
        <Typography color="error" gutterBottom>
          {error}
        </Typography>
        <Button component={Link} to="/products" variant="contained" color="primary">
          Return to Products
        </Button>
      </Container>
    );
  }

  return (
    <Container sx={{ py: 8, textAlign: 'center' }}>
      <Typography variant="h4" component="h1" gutterBottom color="primary">
        Thank you for your purchase!
      </Typography>
      <Typography variant="body1" paragraph>
        Your order has been processed successfully.
      </Typography>
      <Button component={Link} to="/products" variant="contained" color="primary">
        Continue Shopping
      </Button>
    </Container>
  );
};

export default Success;
